import { useParams } from 'react-router-dom';

import { MilesText } from 'components';

import { getIsNew } from 'utils';

import { offerStore } from '../store';

export const Title = () => {
  const { offerId } = useParams();

  const order = offerStore((state) => state.order);

  const isNew = getIsNew(offerId);

  const title = isNew ? 'New Offer' : `Offer #${order}`;

  return (
    <MilesText
      size='xxl'
      className='font-medium'
    >
      {title}
    </MilesText>
  );
};
